module.exports = __webpack_public_path__ + "b11dbdf07cf26ae2c0dca09b87efb35d.svg";